export default "__VITE_PUBLIC_ASSET__48c4fab7__"